import FaqList from './components/Questions/FaqList';
import ResumeSection from './components/ResumeSection';
import LevelSection from './components/LevelSection';
import FileView from './components/FileView';
import ScoreDateBaseSection from './components/ScoreDateBaseSection';
import ProgramPrincipal from './hooks/ProgramPrincipal';
import Loading from '../../shared/Loading/Loading';

const PointsProgram = (props) => {
  const vm = ProgramPrincipal(props)

  return vm.loading ? (
    <div className="flex justify-center py-10">
      <Loading size="28" colorBase='gray-100' colorAccent='personalized' double={true} bold="8" />
    </div>
  ) : (
    <div
      className={`points-program-view bg-gray-100 px-3 sm:px-4 md:px-6 ${
        vm.fileUrlFinal ? 'h-full overflow-hidden' : 'min-h-screen'
      }`}
    >
      {vm.fileUrlFinal ? (
        <FileView
          numPages={vm.numPages}
          pageWidth={vm.pageWidth}
          fileUrl={vm.fileUrlFinal}
          handleCloseViewer={vm.handleCloseViewer}
          onDocumentLoadSuccess={vm.onDocumentLoadSuccess}
        />
      ):(
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-4 md:gap-6 lg:grid-cols-[280px_1fr] xl:grid-cols-[300px_1fr]">
          <ResumeSection
            isEditor={vm.isEditor}
            canSeeProfile={vm.canSeeProfile}
            setProfilePoint={vm.setProfilePoint}
            handleViewTerms={vm.handleViewTerms}
            handleChangeFile={vm.handleChangeFile}
          />
          <div className="space-y-4 md:space-y-6">
            <LevelSection
              theme={props.theme}
              levels={vm.levels}
              isEditor={vm.isEditor}
              setLevels={vm.setLevels}
              updateImage={vm.updateImage}
              getImageUrl={vm.getImageUrl}
              deleteLevel={vm.deleteLevel}
              deleteActivity={vm.deleteActivity}
              handleAddLevel={vm.handleAddLevel}
              saveChangeLevels={vm.saveChangeLevels}
            />
            <ScoreDateBaseSection
              canEdit={vm.canEditScoreDateBase}
              scoreDateBase={vm.scoreDateBase}
              scoreDateDay={vm.scoreDateDay}
              scoreDateMonth={vm.scoreDateMonth}
              setScoreDateDay={vm.setScoreDateDay}
              setScoreDateMonth={vm.setScoreDateMonth}
              saveScoreDateBase={vm.saveScoreDateBase}
            />
            <FaqList
              questions={vm.questions}
              isEditor={vm.isEditor}
              loading={vm.loading}
              setQuestions={vm.setQuestions}
              deleteQuestion={vm.deleteQuestion}
              handleAddQuestion={vm.handleAddQuestion}
              saveChangeQuestions={vm.saveChangeQuestions}
            />
          </div>
        </div>
      )}      
    </div>
  );
};

export default PointsProgram;
